import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";
import striptags from "striptags";
import SwipeOverlayArticleSharing from "./SwipeOverlayArticleShare";

const generateBreadcrumbs = (path: string) => {
  return path
    .split("/")
    .slice(0, -1)
    .filter(Boolean)
    .map((segment) => segment.replace(/-/g, " ").toUpperCase());
};

const SwipeOverlayHeader = ({
  title,
  lead,
  path,
}: {
  title: string;
  lead: string;
  path: string;
}) => {
  const breadcrumbs = generateBreadcrumbs(path);
  const strippedLead = striptags(lead);

  return (
    <Wrapper>
      <BannerWrapper />
      <StyledBr />
      <StyledBreadCrumbs>
        {breadcrumbs.map((crumb, index) => (
          <BreadcrumbItem key={index} isLast={index === breadcrumbs.length - 1}>
            {crumb}
          </BreadcrumbItem>
        ))}
      </StyledBreadCrumbs>
      <Headline>{title}</Headline>
      <Lead>{strippedLead}</Lead>
      <AboutWrapper>
        <SharingWrapper>
          <SwipeOverlayArticleSharing />
        </SharingWrapper>
      </AboutWrapper>
    </Wrapper>
  );
};

export default SwipeOverlayHeader;

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 250px;
  margin-bottom: 31px;
  @media (max-width: ${defaultBreakpoints.large}) {
    height: 100px;
  }
`;

export const StyledBreadCrumbs = styled.nav`
  margin-bottom: 32px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    margin-bottom: 24px;
  }
`;

const BreadcrumbItem = styled.span<{ isLast: boolean }>`
  font-size: 12px;
  line-height: 12px;
  font-weight: 800;
  color: ${({ theme }) => theme.default.color.text.dark};
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  text-transform: uppercase;

  &:after {
    color: ${({ theme }) => theme.default.color.text.dark};
    font-size: 12px;
    content: "\\5C";
    margin-left: 16px;
    margin-right: 16px;
    font-weight: 800;
    text-decoration: initial;
  }

  ${({ isLast }) =>
    isLast &&
    `
    &:after {
      content: "";
    }
  `}
`;

const Headline = styled.h1`
  font-size: 52px;
  font-weight: 800;
  line-height: 60px;
  margin: 0 0 24px;
  color: black;

  @media (max-width: ${defaultBreakpoints.medium}) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const Lead = styled.p`
  font-size: 20px;
  color: gray;
  margin-bottom: 24px;
`;

export const AboutWrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.default.color.text.light}`};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.default.color.text.light}`};
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: end;
  @media (max-width: ${defaultBreakpoints.medium}) {
  }
`;

export const SharingWrapper = styled.div`
  font-size: 1rem;
  svg {
    font-size: 1.4rem;
    &:hover {
      path {
        fill: ${({ theme }) => theme.default.color.primary};
      }
    }
  }
`;

const StyledBr = styled.div`
  height: 21.5px;
`;

const Wrapper = styled.div`
  .br {
    height: 21.5px;
  }
`;
